import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./SignUpFrom2.css";
import Swal from "sweetalert2";
import axios from "axios";
import { baseURLs } from "../constants";




const getQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    firstName: params.get("firstName") || "",
    lastName: params.get("lastName") || "",
    Type_member: params.get("Type_member") || "",
    personalID: params.get("personalID") || "",
  };
};

const SignUpForm = () => {
  const queryParams = getQueryParams();

  const [formData, setFormData] = useState({
    firstName: queryParams.firstName,
    lastName: queryParams.lastName,
    Type_member: queryParams.Type_member,
    personalID: queryParams.personalID,
    email: "",
    phone: "",
    country: "Thailand",
    province: "",
    district: "",
    subdistrict: "",
  });


  const [provincesData, setProvincesData] = useState([]);
  const [amphures, setAmphures] = useState([]);
  const [tambons, setTambons] = useState([]);
  const [selected, setSelected] = useState({

    province_id: undefined,
    amphure_id: undefined,
    tambon_id: undefined,
  });
  useEffect(() => {

  }, [formData]);


  useEffect(() => {

  }, [selected]);
  useEffect(() => {

  }, [formData.Type_member]);

  const handleDropdownChange = (event, selectedField, formField, list, nameField = "name_th") => {
    const value = event.target.value;
    const selectedItem = list.find((item) => item.id == value); // ค้นหาชื่อจาก ID

    setSelected((prev) => ({
      ...prev,
      [selectedField]: value,
    }));

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [formField]: selectedItem ? selectedItem[nameField] : "",
      };

      return updatedData;
    });
  };



  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(
        "https://raw.githubusercontent.com/kongvut/thai-province-data/master/api_province_with_amphure_tambon.json"
      )
      .then((response) => {

        setProvincesData(response.data);
        // const provinceNames = response.data.map(province => province.name_th);

      })
      .catch((error) => console.error("Error fetching provinces:", error));
  }, []);


  const handleInputChange = (event) => {
    const { id, value } = event.target;

    let sanitizedValue = value;

    if (id === "phone") {
      sanitizedValue = sanitizedValue.replace(/\D/g, "");
    }

    setFormData((prevData) => ({
      ...prevData,
      [id]: sanitizedValue,
    }));
  }
  const handleCountryChange = (event) => {

    setFormData((prevData) => ({
      ...prevData,
      country: event.target.value,
    }));
  };
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const handleSubmit = async (event) => {
    event.preventDefault();



    const selectElement = event.target.elements.province_id;
    const selectedIndex = selectElement.selectedIndex;
    const selectedOption = selectElement.options[selectedIndex]; // Get the option element
    setSelectedValue(selectedOption.value); // Get the value
    setSelectedLabel(selectedOption.label); // Get the label

    const { email = "", phone = "", firstName = "", lastName = "", personalID = "" } = formData;

    const slipInput = event.target.slip;
    const slipFile = slipInput?.files[0];
    if (!slipFile) {
      Swal.fire({
        icon: "warning",
        title: "กรุณาอัปโหลดไฟล์สลิป",
        text: "คุณต้องแนบไฟล์สลิปก่อนส่งข้อมูล",
      });
      return;
    }
    if (!email || !phone || !firstName || !lastName || !personalID) {
      if (!email || !phone || !slipFile) {
        Swal.fire({
          icon: "warning",
          title: "ข้อมูลไม่ครบถ้วน",
          text: "กรุณากรอกข้อมูลให้ครบถ้วนและแนบสลิปการโอนเงิน",
        });
        return;
      }
    }
    const generateUploadId = () => {
      const randomNum = Math.floor(10000000 + Math.random() * 90000000);
      return `Aln-${randomNum}`;
    };
    const formDataObj = new FormData();
    formDataObj.append("postedFile", slipFile);

    const fullAddress = [
      formData.address,
      selected.tambon_id ? tambons.find(t => t.id == selected.tambon_id)?.name_th : formData.subdistrict,
      selected.amphure_id ? amphures.find(a => a.id == selected.amphure_id)?.name_th : formData.district,
      selected.province_id ? provincesData.find(p => p.id == selected.province_id)?.name_th : formData.province,
      formData.zipcode
    ].filter(Boolean).join(", ");

    const metadata = {
      FirstName: formData.firstName || "",
      LastName: formData.lastName || "",
      email: formData.email || "",
      personalID: formData.personalID || "",
      uploadId: generateUploadId(),
      uploadPic: slipFile.name,
      telephoneNumber: formData.phone || "",
      address: fullAddress,
      studentCode: formData.studentCode || "",
      facultyName: formData.faculty || "",
      programName: formData.programName || "",
      alumniAccount: formData.alumniAccount || "",
      DegreeLevel: formData.degree || "",
      YearOfgraduation: formData.graduationYear || "",
      Current_Job_Position: formData.job || "",
      Num_YearOfservice: formData.yearsOfWork || "",
      Type_member: getTypeMemberNum(formData.Type_member),
      createdBy: "User",
      createdDate: new Date().toISOString(),
    };
    function getTypeMemberNum(type) {
      switch (type) {
        case "ศิษย์เก่า":
          return "1";
        case "บุคลากร (พนักงานมหาวิทยาลัย)":
          return "2";
        case "บุคลากร (ข้าราชการ)":
          return "3";
        default:
          return "0";
      }
    }
    formDataObj.append("Metadata", JSON.stringify(metadata));



    try {


      const response = await axios.post(
        `${baseURLs.api}/Home/RegAlumniMember`,
        formDataObj,
        {

          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        }
      );



      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "สมัครสมาชิกสำเร็จ",
          text: "รหัสยืนยันตัวตนถูกส่งไปยังอีเมล์ของคุณแล้ว",
        }).then(() =>
          navigate("/member", { state: { email: formData.email, phone: formData.phone } })
        );
      } else {
        Swal.fire({
          icon: "error",
          title: "สมัครสมาชิกไม่สำเร็จ",
          text: "กรุณาลองใหม่อีกครั้ง",
        });
      }
    } catch (err) {
      console.error("API Error:", err.response ? err.response.data : err.message);
      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: err.response?.data?.message || err.message,
      });
    }

  };

  const handleReset = (event) => {
    event.preventDefault();
    Swal.fire({
      title: "คุณแน่ใจหรือไม่?",
      text: "คุณต้องการล้างข้อมูลทั้งหมดหรือไม่?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "ใช่, ล้างข้อมูล!",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        setFormData({
          email: "",
          phone: "",
          country: "Thailand",
          province: "",
          district: "",
          subdistrict: "",
        });
        Swal.fire("ล้างข้อมูลแล้ว!", "ข้อมูลถูกล้างเรียบร้อย", "success");
      }
    });
  };

  const DropdownList = ({
    label,
    id,
    list,
    child,
    childsId = [],
    setChilds = []
  }) => {
    const onChangeHandle = (event) => {
      setChilds.forEach((setChild) => setChild([]));
      const entries = childsId.map((child) => [child, undefined]);
      const unSelectChilds = Object.fromEntries(entries);

      const input = event.target.value;
      const dependId = input ? Number(input) : undefined;
      setSelected((prev) => ({ ...prev, ...unSelectChilds, [id]: dependId }));
      setFormData((prev) => ({
        ...prev,
        [id]: input,
      }));
      if (!input) return;

      if (child) {
        const parent = list.find((item) => item.id === dependId);
        const { [child]: childs } = parent;
        const [setChild] = setChilds;
        setChild(childs);
      }
    };

    return (

      <>
        <div className="form-group mb-3">
          <label htmlFor={id} className="form-label">{label}</label>
          <select className="form-select" id={id} value={selected[id] || ""} onChange={onChangeHandle}>
            <option label="Select ..." />
            {list &&
              list.map((item) => (
                <option
                  key={item.id}
                  value={item.id}
                  label={`${item.name_th} `}
                />
              ))}
          </select>
        </div>
      </>
    );
  };
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked1(document.getElementById("agreement1").checked);
    setIsChecked2(document.getElementById("agreement2").checked);
  };
  return (
    <div
      style={{
        backgroundImage: "url('/RegisterAssoc/tower.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        padding: "50px 40px 40px",
      }}
    >
      <div className="row justify-content-center align-items-center min-vh-100">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card shadow p-4">
            <h2 className="text-center mb-4">SignUp</h2>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label>ชื่อ(FirstName)</label>
                    <input type="text" className="form-control" value={formData.firstName} readOnly />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label>นามสกุล(LastName)</label>
                    <input type="text" className="form-control" value={formData.lastName} readOnly />
                  </div>
                </div>
              </div>
              {/* <div className="d-flex align-items-center "> */}
              <div className="   form-group mb-3">
                <label>ประเภทสมาชิก</label>
                <input type="text" className="form-control" value={formData.Type_member} readOnly />
              </div>
              <div className="  form-group mb-3 ">
                <label>รหัสบัตรประชาชน</label>
                <input type="text" className="form-control" value={formData.personalID} readOnly />
              </div>
              {/* </div> */}
              <div className="form-group mb-3">

                <label htmlFor="email" className="form-label">อีเมล์(Email)<span className="text-danger">*</span></label>

                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="กรอกอีเมล์"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,6}$"
                  title="กรุณากรอกอีเมล์ให้ถูกต้อง เช่น example@example.com"
                />
              </div>

              <div className="form-group mb-3">
                <label htmlFor="phone" className="form-label">เบอร์โทรศัพท์(phone)<span className="text-danger">*</span></label>
                <div className="d-flex">
                  <select
                    className="form-select me-2"
                    id="country"
                    value={formData.country}
                    onChange={handleCountryChange}
                  >
                    <option value="Thailand">+66 (Thailand)</option>
                    <option value="USA">+1 (United States)</option>
                    <option value="UK">+44 (United Kingdom)</option>
                    <option value="Afghanistan">+93 (Afghanistan)</option>
                    <option value="Albania">+355 (Albania)</option>
                    <option value="Algeria">+213 (Algeria)</option>
                    <option value="Andorra">+376 (Andorra)</option>
                    <option value="Angola">+244 (Angola)</option>
                    <option value="Argentina">+54 (Argentina)</option>
                    <option value="Armenia">+374 (Armenia)</option>
                    <option value="Australia">+61 (Australia)</option>
                    <option value="Austria">+43 (Austria)</option>
                    <option value="Azerbaijan">+994 (Azerbaijan)</option>
                    <option value="Bahrain">+973 (Bahrain)</option>
                    <option value="Bangladesh">+880 (Bangladesh)</option>
                    <option value="Belgium">+32 (Belgium)</option>
                    <option value="Brazil">+55 (Brazil)</option>
                    <option value="Canada">+1 (Canada)</option>
                    <option value="Chile">+56 (Chile)</option>
                    <option value="China">+86 (China)</option>
                    <option value="Colombia">+57 (Colombia)</option>
                    <option value="Czech Republic">+420 (Czech Republic)</option>
                    <option value="Denmark">+45 (Denmark)</option>
                    <option value="Egypt">+20 (Egypt)</option>
                    <option value="Finland">+358 (Finland)</option>
                    <option value="France">+33 (France)</option>
                    <option value="Germany">+49 (Germany)</option>
                    <option value="Greece">+30 (Greece)</option>
                    <option value="Hong Kong">+852 (Hong Kong)</option>
                    <option value="Hungary">+36 (Hungary)</option>
                    <option value="India">+91 (India)</option>
                    <option value="Indonesia">+62 (Indonesia)</option>
                    <option value="Iran">+98 (Iran)</option>
                    <option value="Ireland">+353 (Ireland)</option>
                    <option value="Israel">+972 (Israel)</option>
                    <option value="Italy">+39 (Italy)</option>
                    <option value="Japan">+81 (Japan)</option>
                    <option value="Kenya">+254 (Kenya)</option>
                    <option value="Malaysia">+60 (Malaysia)</option>
                    <option value="Mexico">+52 (Mexico)</option>
                    <option value="Netherlands">+31 (Netherlands)</option>
                    <option value="New Zealand">+64 (New Zealand)</option>
                    <option value="Norway">+47 (Norway)</option>
                    <option value="Pakistan">+92 (Pakistan)</option>
                    <option value="Philippines">+63 (Philippines)</option>
                    <option value="Poland">+48 (Poland)</option>
                    <option value="Portugal">+351 (Portugal)</option>
                    <option value="Qatar">+974 (Qatar)</option>
                    <option value="Russia">+7 (Russia)</option>
                    <option value="Saudi Arabia">+966 (Saudi Arabia)</option>
                    <option value="Singapore">+65 (Singapore)</option>
                    <option value="South Africa">+27 (South Africa)</option>
                    <option value="South Korea">+82 (South Korea)</option>
                    <option value="Spain">+34 (Spain)</option>
                    <option value="Sweden">+46 (Sweden)</option>
                    <option value="Switzerland">+41 (Switzerland)</option>
                    <option value="Taiwan">+886 (Taiwan)</option>
                    <option value="Thailand">+66 (Thailand)</option>
                    <option value="Turkey">+90 (Turkey)</option>
                    <option value="United Arab Emirates">+971 (United Arab Emirates)</option>
                    <option value="United Kingdom">+44 (United Kingdom)</option>
                    <option value="United States">+1 (United States)</option>
                    <option value="Vietnam">+84 (Vietnam)</option>

                  </select>
                  <input
                    type="text"
                    className="form-control"
                    id="phone"
                    placeholder="กรอกเบอร์โทรศัพท์"
                    value={formData.phone}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="form-group mb-3">
                <label htmlFor="address" className="form-label">รายละเอียดที่อยู่(address)</label>
                <textarea
                  className="form-control"
                  id="address"
                  rows="2"
                  placeholder="กรอกที่อยู่"
                  value={formData.address}
                  onChange={handleInputChange}
                ></textarea>
              </div>

              {/* Dropdowns for province, district, and subdistrict */}
              <DropdownList
                label="จังหวัด"
                id="province_id"
                list={provincesData}
                child="amphure"
                childsId={["amphure_id", "tambon_id"]}
                setChilds={[setAmphures, setTambons]}
                onChange={(e) => handleDropdownChange(e, "province_id", "province", provincesData)}
              />

              <br />
              <DropdownList
                label="อำเภอ"
                id="amphure_id"
                list={amphures}
                child="tambon"
                childsId={["tambon_id"]}
                setChilds={[setTambons]}
                onChange={(e) => handleDropdownChange(e, "amphure_id", "district", amphures)}
              />
              <br />
              <DropdownList
                label="ตำบล"
                id="tambon_id"
                list={tambons}
                onChange={(e) => handleDropdownChange(e, "tambon_id", "subdistrict", tambons)}
              />
              <br />
              {/* <pre>{JSON.stringify(selected, null, 4)}</pre> */}
              <div className="form-group mb-3">
                <label htmlFor="zipcode" className="form-label">รหัสไปรษณีย์(zipcode)<span className="text-danger">*</span></label>
                <input
                  className="form-control"
                  id="zipcode"
                  rows="2"
                  placeholder="กรอกรหัสไปรษณีย์"
                  value={formData.zipcode}
                  onChange={handleInputChange}
                ></input>
              </div>

              <div className="form-group mb-3">
                <p>
                  สมัครสมาชิก สมาคมศิษย์เก่ามหาวิทยาลัยมหิดล ในพระบรมราชูปถัมภ์

                </p>
                <div>
                  <input type="checkbox" id="agreement1" onChange={handleCheckboxChange} />
                  <br />
                  <label htmlFor="agreement1">
                    สมัครสมาชิก สมาคมศิษย์เก่ามหาวิทยาลัยมหิดล ในพระบรมราชูปถัมภ์ ประเภท-สามัญ (ค่าบำรุงตลอดชีพ 500 บาท)
                  </label>
                  <br />
                  <input type="checkbox" id="agreement2" onChange={handleCheckboxChange} />
                  <br />
                  <label htmlFor="agreement2">
                    ข้าพเจ้าขอรับรองว่าจะปฏิบัติตามข้อบังคับของสมาคมฯ ทุกประการ และแนบสําเนาการโอนมาพร้อมกับนี้
                  </label>

                </div>
              </div>


              <div className="form-group mb-3">
                <label htmlFor="slip" className="form-label2" style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src="/RegisterAssoc/SCB2.jpg"
                    alt="SCB Logo"
                    style={{
                      width: "70px",
                      height: "70px",
                      marginRight: "10px",
                      borderRadius: "50%"  
                    }}
                  />
                  โอนเงินเข้าธนาคารไทยพาณิชย์ <br />
                  ชื่อบัญชี สมาคมศิษย์เก่ามหาวิทยาลัยมหิดล <br />
                  เลขที่บัญชี 333-2-10641-5<br />
                </label>
                <label htmlFor="slip" className="form-label1">
                  Slip การโอนเงินกรุณาอัปโหลดไฟล์ที่เป็น .png หรือ .jpg เท่านั้นขนาดไฟล์ไม่เกิน (5mb)</label>
                <input
                  type="file"
                  name="slip"
                  className="form-control"
                  id="slip"
                  accept=".png, .jpg, .jpeg"

                />
              </div>

              <button type="submit" className="btn btn-primary mb-2" disabled={!(isChecked1 && isChecked2)}>
                สมัครสมาชิก
              </button>
              <button type="reset" className="btn btn-secondary" onClick={handleReset} >ยกเลิก</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};


export default SignUpForm;
